import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=b7d2fc26&scoped=true&v-if=user&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d2fc26",
  null
  
)

export default component.exports